/** Public read-only demo staff credentials (seeded in DB). */

export type DemoShopViewer = {
  email: string
  password: string
  shopHint: string
  /** Staff login query value: /auth/staff/login?demo=<loginQuery> */
  loginQuery: string
  storefrontPath: string
}

export const DEMO_ELECTRONICS_VIEWER: DemoShopViewer = {
  email: 'viewer@demoelectronics.com',
  password: 'viewer123',
  shopHint: 'Demo Electronics',
  loginQuery: 'viewer',
  storefrontPath: '/shop/demostore',
}

export const DEMO_TICKETS_VIEWER: DemoShopViewer = {
  email: 'viewer@demotickets.com',
  password: 'viewer123',
  shopHint: 'Demo Tickets',
  loginQuery: 'tickets-viewer',
  storefrontPath: '/shop/demotickets',
}

export const DEMO_SHOP_VIEWERS = [DEMO_ELECTRONICS_VIEWER, DEMO_TICKETS_VIEWER] as const

export function resolveDemoShopViewer(loginQuery: string | null): DemoShopViewer | null {
  if (!loginQuery) return null
  return DEMO_SHOP_VIEWERS.find((v) => v.loginQuery === loginQuery) ?? null
}
